
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

// require('./bootstrap');

window.Vue = require('vue');

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */
// import CKEditor from '@ckeditor/ckeditor5-vue';

// Vue.component('example-component', require('./components/ExampleComponent.vue'));
Vue.component('search', () => import(/* webpackChunkName: "search-chunk" */ './components/Search.vue'));
Vue.component('upload', () => import(/* webpackChunkName: "upload-chunk" */ './components/Upload.vue'));
Vue.component('add-user', () => import(/* webpackChunkName: "add-user-chunk" */ './components/AddUser.vue'));
Vue.component('login', () => import(/* webpackChunkName: "login-chunk" */ './components/LogIn.vue'));
Vue.component('depots', () => import(/* webpackChunkName: "depots-chunk" */ './components/Depots.vue'));
Vue.component('add-depot-location', () => import(/* webpackChunkName: "add-depot-location-chunk" */ './components/popups/AddDepotLocation.vue'));
Vue.component('users', () => import(/* webpackChunkName: "users-chunk" */ './components/Users.vue'));
Vue.component('new-password', () => import(/* webpackChunkName: "new-password-chunk" */ './components/NewPassword.vue'));
Vue.component('authorization-form', () => import(/* webpackChunkName: "authorization-form-chunk" */ './components/AuthorizationForm.vue'));
Vue.component('survey-upload', () => import(/* webpackChunkName: "survey-upload-chunk" */ './components/SurveyUpload.vue'));
Vue.component('export-import', () => import(/* webpackChunkName: "export-import-chunk" */ './components/ExportImport.vue'));
Vue.component('choose-depot', () => import(/* webpackChunkName: "choose-depot-chunk" */ './components/ChooseDepot.vue'));
Vue.component('authorization-depot', () => import(/* webpackChunkName: "authorization-depot-chunk" */ './components/popups/AuthorizationDepot.vue'));
Vue.component('add-user-depot', () => import(/* webpackChunkName: "add-user-depot-chunk" */ './components/popups/AddUserDepot.vue'));
Vue.component('manual-upload', () => import(/* webpackChunkName: "manual-upload-chunk" */ './components/_manualUpload.vue'));

Vue.component('crons-component', () => import(/* webpackChunkName: "crons-component-chunk" */ './components/dashboard/CronsComponent.vue'));
Vue.component('crons-control-component', () => import(/* webpackChunkName: "crons-control-component-chunk" */ './components/dashboard/CronsControlComponent.vue'));
Vue.component('login-error', () => import(/* webpackChunkName: "login-error-chunk" */ './components/popups/LoginError.vue'));
Vue.component('test-authorization', () => import(/* webpackChunkName: "test-authorization-chunk" */ './components/popups/TestAuthorization.vue'));
Vue.component('ftp-reporting', () => import(/* webpackChunkName: "ftp-reporting-chunk" */ './components/popups/FtpReporting.vue'));
Vue.component('layout-settings', () => import(/* webpackChunkName: "layout-settings-chunk" */ './components/LayoutSettings.vue'));
Vue.component('email-templates-component', () => import(/* webpackChunkName: "email-templates-component-chunk" */ './components/dashboard/EmailTemplatesComponent.vue'));
Vue.component('edit-email-template', () => import(/* webpackChunkName: "edit-email-template-chunk" */ './components/dashboard/popups/EditEmailTemplate.vue'));
Vue.component('add-email', () => import(/* webpackChunkName: "add-email-chunk" */ './components/dashboard/popups/AddEmail.vue'));
Vue.component('admin-panel-component', () => import(/* webpackChunkName: "admin-panel-component-chunk" */ './components/dashboard/AdminPanelComponent.vue'));
Vue.component('sub-domains-component', () => import(/* webpackChunkName: "sub-domains-component-chunk" */ './components/dashboard/SubDomainsComponent.vue'));
Vue.component('set-up-sub-domain-component', () => import(/* webpackChunkName: "set-up-sub-domain-component-chunk" */ './components/dashboard/SetUpSubDomainComponent.vue'));
Vue.component('currency-settings', () => import(/* webpackChunkName: "currency-settings-chunk" */ './components/dashboard/SettingsCurrencie.vue'));
Vue.component('authorities-setting', () => import(/* webpackChunkName: "authorities-setting-chunk" */ './components/dashboard/SettingsAuthorities.vue'));
Vue.component('expired-authorisation-email-setting', () => import(/* webpackChunkName: "expired-authorisation-email-setting-chunk" */ './components/dashboard/SendEmailaboutExpiredSettings.vue'));
Vue.component('survey-setting', () => import(/* webpackChunkName: "survey-setting-chunk" */ './components/dashboard/SurveySettings.vue'));

// Vue.component('survey-page', () => import(/* webpackChunkName: "survey-setting-chunk" */ './components/dashboard/SurveuysPage.vue'));
Vue.component('survey-page', () => import(/* webpackChunkName: "survey-setting-chunk" */ './components/dashboard/SurveyComponent.vue'));
Vue.component('countries-component', () => import(/* webpackChunkName: "countries-component-chunk" */ './components/dashboard/CountriesComponent.vue'));
Vue.component('add-countries-component', () => import(/* webpackChunkName: "add-countries-component-chunk" */ './components/dashboard/AddCountriesComponent.vue'));
Vue.component('cities-component', () => import(/* webpackChunkName: "cities-component-chunk" */ './components/dashboard/CitiesComponent.vue'));
Vue.component('add-cities-component', () => import(/* webpackChunkName: "add-cities-component-chunk" */ './components/dashboard/AddCitiesComponent.vue'));
Vue.component('regions-component', () => import(/* webpackChunkName: "regions-component-chunk" */ './components/dashboard/RegionsComponent.vue'));
Vue.component('add-regions-component', () => import(/* webpackChunkName: "add-regions-component-chunk" */ './components/dashboard/AddRegionsComponent.vue'));
Vue.component('ftp-report', () => import(/* webpackChunkName: "ftp-report-chunk" */ './components/dashboard/FtpUploadReportComponent.vue'));
Vue.component('ftp-daily-report', () => import(/* webpackChunkName: "ftp-daily-report-chunk" */ './components/dashboard/FtpUploadReportDailyComponent.vue'));
Vue.component('ftp-manually', () => import(/* webpackChunkName: "ftp-manually-chunk" */ './components/dashboard/FtpManuallyComponent.vue'));
Vue.component('show-log-message-component', () => import(/* webpackChunkName: "show-log-message-component-chunk" */ './components/dashboard/popups/ShowLogMessageComponent.vue'));
Vue.component('edit-ftp-manually-popup', () => import(/* webpackChunkName: "edit-ftp-manually-popup-chunk" */ './components/dashboard/popups/EditFtpManuallyPopup.vue'));
Vue.component('spec_ga', () => import(/* webpackChunkName: "spec_ga-chunk" */ './components/PdfSpec.vue'));
Vue.component('add_spec_ga', () => import(/* webpackChunkName: "add_spec_ga-chunk" */ './components/AddPdfSpec.vue'));
Vue.component('migration-component', () => import(/* webpackChunkName: "migration-component-chunk" */ './components/dashboard/MigrationComponent.vue'));
Vue.component('email-details-component', () => import(/* webpackChunkName: "email-details-component-chunk" */ './components/dashboard/popups/EmailDetailsComponent.vue'));
Vue.component('logs-component', () => import(/* webpackChunkName: "logs-component-chunk" */ './components/dashboard/LogsComponent.vue'));
Vue.component('emails-component', () => import(/* webpackChunkName: "emails-component-chunk" */ './components/dashboard/EmailsComponent.vue'));

Vue.component('search-result', () => import(/* webpackChunkName: "search-result-chunk" */ './components/dashboard/SearchResult.vue'));
Vue.component('authorisations-component', () => import(/* webpackChunkName: "authorisations-component-chunk" */ './components/dashboard/AuthorisationsComponent.vue'));

Vue.component('edit-pdf', () => import(/* webpackChunkName: "edit-pdf-chunk" */ './components/EditPdf.vue'));
Vue.component('users-page', () => import(/* webpackChunkName: "users-page-chunk" */ './components/dashboard/UsersPageComponent.vue'));
Vue.component('security', () => import(/* webpackChunkName: "security-chunk" */ './components/dashboard/Security.vue'));
Vue.component('add-group', () => import(/* webpackChunkName: "add-group-chunk" */ './components/dashboard/popups/AddGroup.vue'));



const moment = require("moment");
Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('ll')
    }
});

Vue.filter('dateFormat', function(date) {
    if(date && date !='0000-00-00') {
        return moment(date).format('DD MMMM YY HH:mm:ss');
    }
    return '';
});

Vue.prototype.moment = moment;

const app = new Vue({
    el: '#app'
});

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$('#logout').click((e) => {
    e.preventDefault();
    $('#logout_form').submit()
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js